import { format } from 'date-fns';
import React, { useCallback, useState } from 'react';
import { DateFormatOptions } from 'shared/types/date-format-options';
import { Timestamp } from 'shared/types/timestamp';

import { formatDateInput } from './format-date-input';

export const useDateInput = (
  initialValue: Timestamp | undefined,
  dateFormat: DateFormatOptions,
): [
  value: string,
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
] => {
  const [value, setValue] = useState(
    initialValue ? format(initialValue, dateFormat) : '',
  );

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) =>
      setValue(formatDateInput(e.target.value, dateFormat)),
    [dateFormat],
  );

  return [value, onChange];
};
